import { Lazy } from "../core/lazy";
import { StringHelper } from "../helper/string-helper";
import { ObjectHelper } from "../helper/object-helper";
import { DateHelper } from "../helper/date-helper";

export interface ILoadingOptions {
	text?: string;
	showTimer?: boolean;
	totalSteps?: number;
	isHigherOverlay?: boolean;
}

window.addEventListener("unload", () => {
	LoadVm.isRedirecting = true;
});

export class LoadVm {
	public static getInstance = Lazy.singleton(LoadVm);

	public static textApplicationLoad = "Anwendung wird geladen";
	public static textSaveChanges = "Änderungen werden gespeichert";
	public static textLoadLookups = "Referenzen werden geladen";
	public static textLoadPermissions = "Berechtigungen werden geladen";
	public static textLoadSettings = "Einstellungen werden geladen";
	public static textApplyBindings = "Oberfläche wird aufgebaut";
	public static textProcessing = "Aufgabe wird ausgeführt";
	public static textLoadStuff = "Daten werden geladen";

	public static isRedirecting = false;

	public static readonly defaultOptions: ILoadingOptions = {
		text: LoadVm.textProcessing,
		showTimer: true,
		totalSteps: 0,
		isHigherOverlay: false
	};

	private static count: number = 0;

	/**
	 * Same as `LoadVm.rediect`, but is intended for site redireection. Certain network error messages are suppressed.
	 * @param options
	 */
	public static readonly redirect = (options: ILoadingOptions) => {
		LoadVm.isRedirecting = true;
		LoadVm.startLoading(options);
	}

	public static readonly startLoading = (options: ILoadingOptions) => {
		options = ObjectHelper.getTypedMerge<ILoadingOptions>(options, LoadVm.defaultOptions);
		LoadVm.count++;

		let currentLoadVm = LoadVm.getInstance();
		currentLoadVm.startTime(DateHelper.nowAsTicks());
		currentLoadVm.start();
		currentLoadVm.loadText(options.text);
		currentLoadVm.totalSteps(options.totalSteps);
		currentLoadVm.timerIsVisible(options.showTimer);
		currentLoadVm.isHigherOverlay(options.isHigherOverlay);
	}

	public static readonly endLoading = () => {
		LoadVm.count--;
		if (LoadVm.count <= 0) {
			let currentLoadVm = LoadVm.getInstance();
			currentLoadVm.end();
			LoadVm.count = 0;
		}
	}

	public static readonly nextStep = (text: string = "") => {
		let currentLoadVm = LoadVm.getInstance();
		currentLoadVm.currentStepText(text);
		currentLoadVm.currentStep(currentLoadVm.currentStep() + 1);
	}

	constructor() {
		this.initialize();
	}

	public isVisible: KnockoutObservable<boolean> = ko.observable(false);
	public timer: KnockoutObservable<number> = ko.observable(0);
	public timeElapsed: KnockoutObservable<number> = ko.observable(0);
	public timeElapsedFormatString: KnockoutComputed<string> = ko.computed(() => {
		let curTimeElapsed = this.timeElapsed();
		let result = "0:00";
		if (curTimeElapsed) {
			result = `${Math.floor(curTimeElapsed / 60)}:${StringHelper.pad(Math.floor(curTimeElapsed % 60))}`;
		}
		return result;
	});
	public loadText: KnockoutObservable<string> = ko.observable(null);

	public timerIsVisible: KnockoutObservable<boolean> = ko.observable(true);
	public totalSteps: KnockoutObservable<number> = ko.observable(0);
	public currentStepText: KnockoutObservable<string> = ko.observable("");
	public currentStep: KnockoutObservable<number> = ko.observable(0);
	public startTime: KnockoutObservable<number> = ko.observable(null);
	public isHigherOverlay: KnockoutObservable<boolean> = ko.observable(false);

	public currentStepTextComputed = ko.computed(() => {
		return `(${this.currentStep()}/${this.totalSteps()}) ${this.currentStepText()}`;
	});

	public progressBarIsVisible = ko.computed(() => {
		return this.totalSteps() > 0;
	});

	public progressBarOptions = {
		value: this.currentStep,
		max: this.totalSteps,
		showStatus: false
	};

	private initialize() {
		this.timerIsVisible(true);
		this.isVisible(false);
		this.loadText("");
		this.timer(0);
		this.timeElapsed(0);
		this.totalSteps(0);
		this.currentStepText("");
		this.currentStep(0);
	}
	private end() {
		if (!this.isVisible()) {
			return;
		}
		if (this.timer()) {
			window.clearInterval(this.timer());
		}
		this.initialize();
	}
	private start() {
		if (this.isVisible()) {
			this.end();
		}

		this.timer(window.setInterval(() => {
			if (!this.timerIsVisible()) {
				return;
			}
			let curTime = DateHelper.nowAsTicks();
			let startTime = this.startTime();
			this.timeElapsed((curTime - startTime) / 1000);
		}, 500));
		this.isVisible(true);
	}
}